import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
  <div id="footer">
		<h2 class="offleft">Footer</h2>
		<div class="footerlinks">
			<a href="https://www.ars.usda.gov/northeast-area/" target="_blank">BARC Home</a>&nbsp;|&nbsp;
			<a href="https://www.ars.usda.gov/" target="_blank">ARS Home</a>&nbsp;|&nbsp;
			<a href="https://www.usda.gov/" target="_blank">USDA.gov</a>&nbsp;|&nbsp;
			<a href="https://www.epa.gov/" target="_blank">EPA.gov</a>&nbsp;|&nbsp;
			<a href="https://www.usda.gov/policies-and-links/" target="_blank">Policies and Links</a>&nbsp;|&nbsp;
		</div>
		<div id="footercorner">
			<img src="../images/footer_corner.gif" height="22" width="24" alt="" border="0" />
		</div>
		<div class="footerlinks">
			<a href="https://www.ars.usda.gov/oc/foia/freedom-of-information-act-and-privacy-act-reference-guide/" target="_blank">FOIA</a>&nbsp;|&nbsp;
			<a href="https://www.usda.gov/accessibility-statement" target="_blank">Accessibility Statement</a>&nbsp;|&nbsp;
			<a href="https://www.usda.gov/privacy-policy" target="_blank">Privacy Policy</a>&nbsp;|&nbsp;
			<a href="https://www.usda.gov/non-discrimination-statement" target="_blank">Non-Discrimination Statement</a>&nbsp;|&nbsp;
			<a href="https://www.ars.usda.gov/docs/quality-of-information/" target="_blank">Quality of Information</a>&nbsp;|&nbsp;
			<a href="https://www.usa.gov" target="_blank">USA.gov</a>&nbsp;|&nbsp;
			<a href="https://www.whitehouse.gov" target="_blank">WhiteHouse.gov</a>
		</div>
		<br class="clearfloat"/>
	</div>`
})
export class FooterComponent { }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/footer.ts